import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { Team, User } from '@app/shared';

import { environment } from 'environments/environment';
import { RequestService } from './request.service';
import { URLSearchParams } from '@angular/http';


@Injectable()
export class TeamService implements RequestService {

  redirectUrl: String = "";
  isBusy = false;
  private serviceUrl = 'team';  // URL to web api

  constructor(
    private http: HttpClient,
    ) { }


  /** GET product by id. Will 404 if id not found */
  /** GET product by id. Will 404 if id not found */
  getGlobalTeams(): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}${this.serviceUrl}/global`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Team[]>(encodeURI(url),{
       //params : httpParams
       headers: headers
    })
  }


  getTeam(team:Team): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}${this.serviceUrl}/${team.id}/team`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Team>(url,{
       //params : httpParams
       headers: headers
    })

  }

  updateTeam(team:Team): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    let action= team.id?'save':'save'
    const url = `${environment.baseURL}${this.serviceUrl}/${action}`;
    const ignoreKeys = ['members','offers','id','tags'];

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    let urlSearchParams = new URLSearchParams();

    let data = {id:-1,colour:'',tags:'',descr:'',name:''};

    if(team.id)
      data.id = team.id;
    else
      delete data['id'];

    if(team.tags)
      data.tags = team.tags.join();

    Object.keys(team).forEach(function (key) {
      if(ignoreKeys.indexOf(key) === -1 && team[key])
        data[key] =  team[key];
    });

    urlSearchParams.append('data',JSON.stringify(data));

    let bodyParams = urlSearchParams.toString();

    return this.http.post<Team>(url,bodyParams,{
       //params : httpParams
       headers: headers
    })

  }

  getTeamMembers(team:Team): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}${this.serviceUrl}/${team.id}/members?include=persons`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })

    return this.http.get<Team>(url,{
       //params : httpParams
       headers: headers
    })

  }

  addTeamMember(team:Team,member:User): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}${this.serviceUrl}/${team.id}/members/${member.uuid}`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    let urlSearchParams = new URLSearchParams();

    urlSearchParams.append('teamID',JSON.stringify(team.id));
    urlSearchParams.append('personUUID',member.uuid);
    let bodyParams = urlSearchParams.toString();

    return this.http.post(url,bodyParams,{
       //params : httpParams
       headers: headers
    })

  }

  removeTeamMember(team:Team,member:User): Observable<any> {
    //const body = {e: 'username', p: 'password', rt:'json'};
    const url = `${environment.baseURL}${this.serviceUrl}/${team.id}/members/${member.uuid}`;

    let httpParams = new HttpParams();
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    let urlSearchParams = new URLSearchParams();

    httpParams.set('teamID',JSON.stringify(team.id));
    httpParams.set('personUUID',member.uuid);
    let bodyParams = urlSearchParams.toString();

    return this.http.delete(url)

  }



  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T> (operation = 'operation', result?: T) {

    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better team of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.

      return of(result as T);
    };
  }
  /** Log a UserService message with the MessageService */
  private log(message: string) {
    //this.messageService.add('UserService: ' + message);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/core/services/team.service.ts